import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  title: {
    // The h2 DialogTitle renders; Mui* class names get numeric suffixes under a nested ThemeProvider.
    ...reskinStyles(theme, { '& > h2': theme.modalTitle })
  },
  mContent: {
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    padding: theme.spacing(10, 12),
    backgroundColor: theme.colors.modal__background_primary,
    '&:first-child': {
      paddingTop: theme.spacing(10)
    }
  },
  blockContent: {
    position: 'relative',
    padding: theme.spacing(10, 12),
    backgroundColor: theme.colors.modal__background_primary,
    '&:first-child': {
      paddingTop: theme.spacing(10)
    }
  },
  closeButton: {
    position: 'absolute',
    top: 5,
    right: 5
  }
}));
